import { ReactComponent as ChallengeDonationsIcon } from '../../assets/icons/v3/challenge-donations.svg';
import { ReactComponent as ChallengeMeditationIcon } from '../../assets/icons/v3/challenge-meditation.svg';
import { ReactComponent as ChallengeStepsIcon } from '../../assets/icons/v3/challenge-steps.svg';
import { ReactComponent as ChallengeTrainingIcon } from '../../assets/icons/v3/challenge-training.svg';
import assistance from '../../assets/icons/v3/protection/insurance-assistence.svg?url';
import bikeIcon from '../../assets/icons/v3/protection/insurance-bike.svg?url';
import cancerIcon from '../../assets/icons/v3/protection/insurance-cancer.svg?url';
import complementaryIcon from '../../assets/icons/v3/protection/insurance-complementary.svg?url';
import dentalIcon from '../../assets/icons/v3/protection/insurance-dental.svg?url';
import groupIcon from '../../assets/icons/v3/protection/insurance-group.svg?url';
import medicineIcon from '../../assets/icons/v3/protection/insurance-medicine.svg?url';
import petIcon from '../../assets/icons/v3/protection/insurance-pet.svg?url';
import moneyIcon from '../../assets/icons/v3/protection/insurance-save-money.svg?url';
import { ChallengeRankingType } from '../interfaces/metrics';
import { ITabBarButtonImage } from '../interfaces/tabbars';
import { TRANSLATIONS_METRICS_NE } from '../translations/metrics';

export const PERIOD_SELECTED_MONTH = 'selectedMonth';
export const PERIOD_LAST_THREE_MONTHS = 'lastThreeMonths';
export const PERIOD_LAST_TWELVE_MONTHS = 'lastTwelveMonths';

export const protectionType: Record<string, { icon: string; title: string }> = {
  assistance: { icon: assistance, title: TRANSLATIONS_METRICS_NE.protections.types.assistance },
  bike: { icon: bikeIcon, title: TRANSLATIONS_METRICS_NE.protections.types.bike },
  cancer: { icon: cancerIcon, title: TRANSLATIONS_METRICS_NE.protections.types.cancer },
  health: { icon: complementaryIcon, title: TRANSLATIONS_METRICS_NE.protections.types.health },
  dental: { icon: dentalIcon, title: TRANSLATIONS_METRICS_NE.protections.types.dental },
  life: { icon: groupIcon, title: TRANSLATIONS_METRICS_NE.protections.types.life },
  pharmacy: { icon: medicineIcon, title: TRANSLATIONS_METRICS_NE.protections.types.pharmacy },
  supplemental: { icon: complementaryIcon, title: TRANSLATIONS_METRICS_NE.protections.types.supplemental },
  pet: { icon: petIcon, title: TRANSLATIONS_METRICS_NE.protections.types.pet },
  fraud: { icon: moneyIcon, title: TRANSLATIONS_METRICS_NE.protections.types.fraud }
};

export const METRICS_TIMER_SELECTOR = {
  title: TRANSLATIONS_METRICS_NE.timerSelector.title,
  buttonThreeMonths: TRANSLATIONS_METRICS_NE.timerSelector.buttonThreeMonths,
  buttonTwelveMonths: TRANSLATIONS_METRICS_NE.timerSelector.buttonTwelveMonths,
  lastThreeMonths: TRANSLATIONS_METRICS_NE.timerSelector.lastThreeMonths,
  lastTwelveMonths: TRANSLATIONS_METRICS_NE.timerSelector.lastTwelveMonths
};

export const METRICS_COMING_SOON = {
  title: TRANSLATIONS_METRICS_NE.comingSoonCard.title,
  description: TRANSLATIONS_METRICS_NE.comingSoonCard.description
};

export const METRICS_TABS = [
  {
    title: TRANSLATIONS_METRICS_NE.tabs.collaborators,
    type: 'collaborators',
    color: 'hero-collaborators',
    gtmTab: 'collaborators'
  },
  {
    title: TRANSLATIONS_METRICS_NE.tabs.benefits,
    type: 'benefits',
    color: 'hero-benefits',
    gtmTab: 'benefits'
  },
  {
    title: TRANSLATIONS_METRICS_NE.tabs.donations,
    type: 'donations',
    color: 'hero-donations',
    gtmTab: 'donations'
  },
  {
    title: TRANSLATIONS_METRICS_NE.tabs.protection,
    type: 'protection',
    color: 'hero-protection',
    gtmTab: 'protection'
  },
  {
    title: TRANSLATIONS_METRICS_NE.tabs.challenges,
    type: 'challenges',
    color: 'hero-challenges',
    gtmTab: 'challenges'
  }
];

export const METRICS_PERIOD_SELECTED_MONTH = 'selectedMonth';
export const METRICS_PERIOD_HISTORICAL = 'historical';
export const BETTERFLIES_RANKING_PAGE_SIZE = 50;
export const CHALLENGE_RANKING_PAGE_SIZE = 20;

export const CHALLENGE_RANKING_TYPES: Record<ChallengeRankingType, { label: string; icon: ITabBarButtonImage }> = {
  steps: { label: TRANSLATIONS_METRICS_NE.challenges.ranking.types.steps, icon: { component: ChallengeStepsIcon } },
  donations: {
    label: TRANSLATIONS_METRICS_NE.challenges.ranking.types.donations,
    icon: { component: ChallengeDonationsIcon }
  },
  training: {
    label: TRANSLATIONS_METRICS_NE.challenges.ranking.types.training,
    icon: { component: ChallengeTrainingIcon }
  },
  meditation: {
    label: TRANSLATIONS_METRICS_NE.challenges.ranking.types.meditation,
    icon: { component: ChallengeMeditationIcon }
  }
};
